// src/services/notificationsApi.ts

import api from '@/config/axios';
import type { Notification, NotificationsListResponse, UnreadCountResponse, ListNotificationsParams } from '@/types/notifications';

/**
 * API de Notificações
 */
export const notificationsApi = {
    /**
     * Listar notificações do usuário autenticado
     */
    async getNotifications(params: ListNotificationsParams = {}): Promise<NotificationsListResponse> {
        const queryParams = new URLSearchParams();

        if (params.limit) {
            queryParams.append('limit', params.limit.toString());
        }
        if (params.offset) {
            queryParams.append('offset', params.offset.toString());
        }
        if (params.unreadOnly) {
            queryParams.append('unreadOnly', 'true');
        }

        const queryString = queryParams.toString();
        const url = `/notifications${queryString ? `?${queryString}` : ''}`;

        const response = await api.get<NotificationsListResponse>(url);
        return response.data;
    },

    /**
     * Obter contador de notificações não lidas
     */
    async getUnreadCount(): Promise<number> {
        const response = await api.get<UnreadCountResponse>('/notifications/unread-count');
        return response.data.count;
    },

    /**
     * Buscar notificação por ID
     */
    async getById(id: number): Promise<Notification> {
        const response = await api.get<Notification>(`/notifications/${id}`);
        return response.data;
    },

    /**
     * Marcar notificação como lida
     */
    async markAsRead(id: number): Promise<Notification> {
        const response = await api.patch<Notification>(`/notifications/${id}/read`);
        return response.data;
    },

    /**
     * Marcar todas as notificações como lidas
     */
    async markAllAsRead(): Promise<{ message: string; count: number }> {
        const response = await api.patch<{ message: string; count: number }>('/notifications/read-all');
        return response.data;
    },

    /**
     * Excluir notificação
     */
    async deleteNotification(id: number): Promise<{ message: string }> {
        const response = await api.delete<{ message: string }>(`/notifications/${id}`);
        return response.data;
    }
};

export default notificationsApi;
